// IUser was removed — use IUserProfileResponse from @core/interface instead
export type { IUserProfileResponse } from '@core/interface';
